import React from "react";

const IconExchange = ({}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
    >
      <g clipPath="url(#clip0_3492_36048)">
        <path
          d="M9.86011 5.5001C9.86011 3.56747 8.71555 1.81852 6.94428 1.04451C6.71416 0.943962 6.44622 1.04896 6.34574 1.27902C6.24526 1.50904 6.35026 1.77701 6.58022 1.87752C8.02041 2.50685 8.95101 3.92877 8.95101 5.5001C8.95101 6.74494 8.36559 7.89677 7.40579 8.63442L7.71454 7.08223C7.76351 6.83602 7.60363 6.59669 7.35742 6.54773C7.11109 6.49879 6.87191 6.65863 6.82292 6.90484L6.31653 9.45041C6.29304 9.56865 6.31741 9.69138 6.38441 9.79165C6.45138 9.89189 6.55543 9.9614 6.67365 9.98492L9.21924 10.4912C9.24918 10.4972 9.27903 10.5001 9.30842 10.5001C9.52084 10.5001 9.71069 10.3504 9.75372 10.1341C9.80269 9.88789 9.64281 9.64862 9.3966 9.59962L8.00247 9.32235C9.15767 8.41394 9.86011 7.01269 9.86011 5.5001Z"
          fill="black"
        />
        <path
          d="M2.64258 4.4523C2.67252 4.45824 2.70237 4.46112 2.73176 4.46112C2.94418 4.46112 3.13403 4.31145 3.17706 4.09515L3.68338 1.54959C3.73235 1.30338 3.57248 1.06408 3.32627 1.01511L0.78076 0.508785C0.534552 0.459937 0.295252 0.619722 0.246253 0.8659C0.197284 1.11214 0.35716 1.35141 0.603369 1.40041L1.99859 1.67789C0.843486 2.58721 0.139648 3.99073 0.139648 5.50004C0.139648 7.43274 1.28421 9.18165 3.05551 9.95561C3.11478 9.98149 3.17651 9.99376 3.23727 9.99376C3.41242 9.99376 3.57938 9.89188 3.65402 9.7211C3.7545 9.49104 3.64953 9.22308 3.41951 9.12259C1.97935 8.4933 1.04876 7.07138 1.04876 5.50004C1.04876 4.25827 1.63484 3.10453 2.59413 2.36618L2.28546 3.91782C2.2365 4.16403 2.39637 4.4033 2.64258 4.4523Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_3492_36048">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconExchange;
